// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"69578402","185":"c165c850","719":"953905e5","820":"f80fdc60"}[chunkId] + ".chunk.js";
};